module.exports = __webpack_public_path__ + "img/check1.91d65229.png";